import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

/**
 * Headers que somem no /dashboard do celular v3 (S1 §2, dec. 37 e 67): a barra do app e o
 * cabeçalho do dashboard saem de cena ao rolar a grade para baixo e voltam ao subir.
 *
 * `hideHeight` é a altura (px) a esconder; 0 = recurso inativo (fora do /dashboard v3) e o
 * `DashboardLayout` não aplica nada. `locked` (seleção em lote ativa) força os headers visíveis.
 * O `MobileS1View` chama `$reset()` ao desmontar: desligar a v3 não deixa transform residual.
 */
export const useDashboardChromeStore = defineStore('dashboardChrome', () => {
  const hiddenRaw = ref(false)
  const hideHeight = ref(0)
  const locked = ref(false)

  const hidden = computed(() => !locked.value && hiddenRaw.value)
  /**
   * R1-04: px dos headers ainda na tela. A coluna do layout fica `hideHeight` px mais alta
   * (altura constante, sem reflow); com os headers visíveis, os últimos `visibleInset` px do
   * conteúdo ficam abaixo da dobra. Overlays do rodapé (pílula, vazio, esqueleto) e o fim da
   * área rolável da S1 descontam este valor (CSS var `--chrome-visible-inset` na coluna).
   */
  const visibleInset = computed(() => (hidden.value ? 0 : hideHeight.value))

  function setHidden(h: boolean) {
    hiddenRaw.value = h
  }
  function setHideHeight(px: number) {
    hideHeight.value = Math.max(0, Math.round(px))
  }
  function setLocked(l: boolean) {
    locked.value = l
    if (l) hiddenRaw.value = false
  }
  function $reset() {
    hiddenRaw.value = false
    hideHeight.value = 0
    locked.value = false
  }

  return { hidden, hideHeight, visibleInset, locked, setHidden, setHideHeight, setLocked, $reset }
})
